import { Box, Typography } from '@mui/material';
import { formatAutoRenewing } from '../utils/callbacks';

interface SubscriptionDetailsProps {
  subscriptionId?: string | null;
  subscriptionEvent?: string | null;
  nextChargeTime?: string | null;
  autoRenewing?: boolean | null;
}

export const SubscriptionDetails: React.FC<SubscriptionDetailsProps> = ({
  subscriptionId,
  subscriptionEvent,
  nextChargeTime,
  autoRenewing,
}) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
    <Typography variant="body2">
      <strong>ID:</strong>{' '}
      <span data-testid="subscription-id">{subscriptionId || '—'}</span>
    </Typography>
    <Typography variant="body2">
      <strong>Event:</strong>{' '}
      <span data-testid="subscription-event">{subscriptionEvent || '—'}</span>
    </Typography>
    <Typography variant="body2">
      <strong>Next charge:</strong>{' '}
      <span data-testid="subscription-next-charge">{nextChargeTime || '—'}</span>
    </Typography>
    <Typography variant="body2">
      <strong>Auto-renew:</strong>{' '}
      <span data-testid="subscription-auto-renew">{formatAutoRenewing(autoRenewing)}</span>
    </Typography>
  </Box>
);

export default SubscriptionDetails;
